import React from 'react';
import { IListItem, ListItem } from './ListItem';
import clsx from 'clsx';

export interface IList {
  listItems: IListItem[];
  divide?: boolean;
  isHorizontal?: boolean;
  className?: string;
  classNameItem?: string;
  full?: boolean;
}

export const List = ({
  className,
  classNameItem,
  listItems,
  divide,
  isHorizontal,
  full = true,
}: IList) => (
  <ul
    role='list'
    className={clsx(
      className,
      divide
        ? isHorizontal
          ? 'divide-x divide-gray-400'
          : 'divide-y divide-gray-400'
        : '',
      full ? (isHorizontal ? 'flex w-full' : 'w-full') : undefined
    )}>
    {listItems?.map((item) => (
      <ListItem
        className={classNameItem}
        {...item}
      />
    ))}
  </ul>
);
